/**
 * Palmiye Gurme — koleksiyon filtre / sıralama (Tur 7)
 * Shopify'ın yerel mağaza filtreleri GET formu ile çalışır (JS kapalıyken de "Uygula" ile çalışır).
 * - Masaüstü: kutucuk değişince form hemen gönderilir.
 * - Mobil (<990px): filtreler tam ekran panelde seçilir, "Ürünleri gör" ile uygulanır.
 * - Sıralama: seçim değişince aynı form gönderilir (aktif filtreler korunur).
 * Boş fiyat alanları gönderilmez → temiz URL.
 */
(() => {
  if (window.__pgCollection) return;
  window.__pgCollection = true;

  const mobile = () => window.matchMedia('(max-width: 989px)').matches;

  function submit(form) {
    if (!form) return;
    form.querySelectorAll('input[type="number"]').forEach((i) => { i.disabled = i.value === ''; });
    const root = form.closest('[data-pg-collection]') || document;
    root.querySelector('.pg-collection__main')?.setAttribute('aria-busy', 'true');
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  let t = null;
  document.addEventListener('change', (e) => {
    const sort = e.target.closest?.('[data-pg-sort]');
    if (sort) { submit(sort.form || document.getElementById(sort.getAttribute('form'))); return; }

    const form = e.target.closest?.('[data-pg-facets]');
    if (!form || e.target.type === 'number') return;
    if (mobile()) { form.dataset.dirty = '1'; return; }
    clearTimeout(t);
    t = setTimeout(() => submit(form), 120);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('[data-pg-facets]');
    if (form) form.querySelectorAll('input[type="number"]').forEach((i) => { i.disabled = i.value === ''; });
  });

  /* ---- mobil panel ---- */
  let lastTrigger = null;
  function openAside(btn) {
    const aside = document.getElementById(btn.getAttribute('aria-controls'));
    if (!aside) return;
    lastTrigger = btn;
    // Kapsayıcıların transform / overflow kuralları "position: fixed"i sınırlamasın → panel <body>'ye taşınır
    if (aside.parentElement !== document.body) {
      aside.__pgHome = document.createComment('pg-aside');
      aside.parentElement.insertBefore(aside.__pgHome, aside);
      document.body.appendChild(aside);
    }
    aside.classList.add('is-open');
    aside.setAttribute('role', 'dialog');
    aside.setAttribute('aria-modal', 'true');
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pg-scroll-lock');
    aside.querySelector('[data-pg-filter-close]')?.focus();
  }
  function closeAside(aside, apply) {
    if (!aside) return;
    const form = aside.querySelector('[data-pg-facets]');
    if (apply && form && form.dataset.dirty === '1') { submit(form); return; }
    aside.classList.remove('is-open');
    if (aside.__pgHome && aside.__pgHome.parentNode) {
      aside.__pgHome.parentNode.insertBefore(aside, aside.__pgHome);
      aside.__pgHome.remove();
      aside.__pgHome = null;
    }
    aside.removeAttribute('role');
    aside.removeAttribute('aria-modal');
    document.documentElement.classList.remove('pg-scroll-lock');
    if (lastTrigger) { lastTrigger.setAttribute('aria-expanded', 'false'); lastTrigger.focus(); }
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest?.('[data-pg-filter-open]');
    if (open) { openAside(open); return; }
    const close = e.target.closest?.('[data-pg-filter-close]');
    if (close) {
      const aside = close.closest('[data-pg-aside]');
      closeAside(aside, close.classList.contains('pg-btn'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const aside = document.querySelector('[data-pg-aside].is-open');
    if (aside) closeAside(aside, false);
  });
  /* Mobilde sıralama seçicisi "Filtrele" ile aynı yapışkan çubuğa taşınır (tek select → tek sort_by). */
  function placeSort() {
    document.querySelectorAll('[data-pg-collection]').forEach((root) => {
      const sort = root.querySelector('.pg-collection__sort');
      const bar = root.querySelector('.pg-collection__mobilebar');
      const head = root.querySelector('.pg-collection__head');
      if (!sort || !bar || !head) return;
      if (mobile() && sort.parentElement !== bar) bar.appendChild(sort);
      else if (!mobile() && sort.parentElement !== head) head.appendChild(sort);
    });
  }
  placeSort();
  document.addEventListener('DOMContentLoaded', placeSort);

  window.addEventListener('resize', () => {
    placeSort();
    const aside = document.querySelector('[data-pg-aside].is-open');
    if (aside && !mobile()) closeAside(aside, false);
  });
})();
